<template>
    <v-app>
        <v-content>
            <v-container style="max-width: 1200px" pt-5>
                <a class="pt-5 pb-4" href="/dashboard">Личный кабинет</a>
                <span v-if="isAdmin" style="color: #00ba57">/</span>
                <a class="pt-5 pb-4" href="/agents" v-if="isAdmin">Список пользователей</a>
                <h1 class="pt-4 pb-4">
                    {{ isAdmin ? fio.surname + ' ' + fio.name + ' ' + fio.patronymic : 'Профиль' }}</h1>

                <v-layout v-if="isAdmin && user.is_egarant && user.egarant_company" pt-0 pb-4 row wrap>
                    <v-flex xs12>
                        <v-label>Оформляет Е-Гарант для {{ user.egarant_company_name }}</v-label>
                    </v-flex>
                </v-layout>

                <p class="pb-5">Начало сотрудничества: {{ startDate }} {{
                        status === 'banned' ? '(Заблокирован)' : ''
                    }}</p>

                <v-layout class="agent-actions" row wrap mb-5 pb-3 v-if="isAdmin">
                    <a @click="approve" v-show="status === 'unapproved'">
                        <img src="/svg/approve.svg" alt=""/>
                        Одобрить
                    </a>
                    <a @click="ban" v-show="status !== 'banned'">
                        <img src="/svg/ban.svg" alt=""/>
                        Заблокировать
                    </a>
                    <a @click="ban" v-show="status === 'banned'">
                        <img src="/svg/ban.svg" alt=""/>
                        Разблокировать
                    </a>
                    <a @click="del" v-show="!deleted">
                        <img src="/svg/add.svg" alt="" style="transform: rotate(-45deg)"/>
                        Удалить
                    </a>
                </v-layout>

                <v-layout row wrap pb-3>
                    <v-tabs style="width: 100%;"
                            v-model="tab"
                            :grow="true"
                            slider-color="#000"
                    >
                        <v-tab
                            v-for="item in tabItems"
                            :key="item"
                        >
                            {{ item }}
                        </v-tab>
                    </v-tabs>
                </v-layout>
            </v-container>

            <v-form ref="personalForm" class="personal-form" v-model="personalValid" v-show="tab === personalTab">
                <v-container style="max-width: 1200px">
                    <v-layout pt-0 row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.surname"
                                :allowAll="userType === 'operator'"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.name"
                                :allowAll="userType === 'operator'"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.patronymic"
                                :allowAll="userType === 'operator'"
                                label="Отчество"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pb-2>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="user.phone"
                                :rules="[rules.phone]"
                                mask="+7 ### ### ## ##"
                                label="Телефон"
                                :disabled="!isAdmin"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0>
                            <v-text-field
                                v-model="user.email"
                                :rules="[rules.email]"
                                label="e-mail"
                                :disabled="!isAdmin"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12 lg4 py-0>
                            <osago-city-dadata :model="city"></osago-city-dadata>
                        </v-flex>
                        <v-flex xs12 md3 lg2 py-0 v-if="!isAgent && isAdmin">
                            <v-checkbox
                                v-model="user.show_commission"
                                label="Показывать КВ"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-checkbox
                                v-if="(authUserIsAdmin || authUserIsCurator || authUserIsAgent) && isAdmin"
                                v-model="user.show_commission_bp"
                                label="Показывать КВ (Банковские продукты)"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap pb-2 v-if="showSalesType">
                        <v-flex xs12 md6 lg4 py-0>
                            <v-select
                                v-model="user.sales_type"
                                label="Тип продаж"
                                :items="salesTypesArray"
                                :rules="[rules.required]"
                                validate-on-blur
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0 v-if="user.sales_type === 'transit'">
                            <v-autocomplete
                                v-model="user.border_crossing_id"
                                label="Пограничный переход"
                                :items="borderCrossingsArray"
                                :rules="[user.sales_type === 'transit' ? rules.required : null]"
                                validate-on-blur
                                required
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout class="agent-products-permissions" v-if="(authUserIsAdmin || authUserIsCurator)">
                        <v-flex xs12 py-0>
                            <v-checkbox
                                v-model="productsPermissions.isTransitOpen"
                                label="Открыть ОСАГО не РФ"
                                :readonly="authUserIsCurator"
                                :disabled="authUserIsCurator"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-2 pb-2 v-if="!isAdmin">
                        <img src="/svg/info.svg" alt="" style="width: 20px; margin: 0 10px;"/>
                        Для смены телефона или почты обратитесь в поддержку.
                    </v-layout>

                    <h3 class="pt-5 pb-3">Пароль</h3>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password"
                                :rules="[rules.newPassword]"
                                label="Новый пароль"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer"
                                            @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password_check"
                                :rules="[passwordCheckRule]"
                                label="Подтвердите пароль"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer"
                                            @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout pt-2 row wrap>
                        <v-flex xs12>
                            <v-checkbox
                                v-model="profileApproved"
                                :rules="[rules.approve]"
                                validate-on-blur
                            >
                                <template v-slot:label>
                                    Подтверждаю достоверность указанных данных
                                </template>
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>

            <v-form ref="requisitesForm" class="requisites-form" v-model="requisitesValid"
                    v-show="tab === requisitesTab">
                <v-container style="max-width: 1200px">
                    <v-layout v-show="isAdmin" pt-0 row wrap>
                        <v-radio-group v-if="canEditType" v-model="type" row
                                       v-on:change="changeType"
                                       :rules="[rules.required]"
                        >
                            <v-radio label="Физ. Лицо"
                                     value="physical">
                            </v-radio>
                            <v-radio label="Юр. Лицо"
                                     value="juridical">
                            </v-radio>
                            <v-radio label="ИП"
                                     value="sole-proprietor">
                            </v-radio>
                            <v-radio label="Самозанятый"
                                     value="self-employed">
                            </v-radio>
                        </v-radio-group>
                    </v-layout>

                    <v-layout v-if="!isAdmin && isAgent" row wrap pt-2 pb-2>
                        <v-flex xs12 sm9 md8 lg7 py-0>
                            <p style="font-size: 18px"><b>ВНИМАНИЕ:</b> Указываете настоящие данные, без опечаток. ФИО
                                должны совпадать
                                с владельцем карты/счета. Указывайте именно ваши данные, НЕ брата, сестры,
                                тещи и т.п. В противном случае, мы не сможем сделать вам выплату.</p>
                        </v-flex>
                    </v-layout>

                    <v-checkbox
                        v-if="isAgent"
                        v-show="isJuridical" pb-5
                        label="Упрощенная система налогообложения"
                        v-model="jur.simple_tax_system"
                        @change=""
                    ></v-checkbox>

                    <v-layout row wrap v-if="isAgent">
                        <v-flex v-if="type === 'juridical'" xs12 md12 lg12 py-0>
                            <v-text-field
                                v-model="jur.name"
                                :rules="[rules.required]"
                                label="Название Юр лица"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex v-if="type === 'sole-proprietor'" xs12 md12 lg12 py-0>
                            <v-text-field
                                v-model="jur.name"
                                :rules="[rules.required]"
                                label="Наименование ИП"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg3 py-0 v-if="type !== 'juridical'">
                            <v-text-field
                                v-if="type !== 'juridical'"
                                v-model="passport.series_number"
                                :rules="[rules.passport]"
                                label="Серия и номер паспорта"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0 v-if="type !== 'juridical'">
                            <osago-date
                                v-model="birthday"
                                label="Дата рождения"
                                :max="passportMaxDate"
                            />
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg4 py-0>
                            <osago-address-dadata
                                :model="address"
                                label="Почтовый адрес"
                            />
                        </v-flex>
                        <v-flex v-if="type !== 'juridical'" xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="snils"
                                :rules="[rules.required]"
                                label="СНИЛС"
                                mask="###-###-### ##"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-if="type === 'juridical'"
                                v-model="bank.inn"
                                :rules="[rules.required, rules.innJuridical,]"
                                label="ИНН"
                                mask="##########"
                                validate-on-blur
                                required
                            ></v-text-field>
                            <v-text-field
                                v-if="type !== 'juridical'"
                                v-model="bank.inn"
                                :rules="[rules.required, rules.inn, validateInn]"
                                label="ИНН"
                                mask="############"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md12 lg12 py-0>
                            <v-text-field
                                v-model="bank.name"
                                :rules="[rules.required]"
                                label="Название банка"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="bank.bik"
                                :rules="[rules.required, rules.bik]"
                                mask="#########"
                                label="БИК банка"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="bank.account_number"
                                :rules="[rules.required, rules.accNumber]"
                                mask="####################"
                                label="Номер расчетного счета"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap v-if="type === 'physical'">
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="bank.card_number"
                                label="Номер банковской карты"
                                mask="#### #### #### #### ##"
                                :rules="[rules.required, rules.cardNumber]"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="bank.fio"
                                label="ФИО Держателя карты"
                                :rules="[rules.required]"
                                :allowLatinAndRussian="true"
                                required
                            ></osago-name>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-autocomplete
                                v-model="bank.issuing_bank"
                                :items="bankList"
                                label="Банк эмитент карты"
                                :rules="[rules.required]"
                                required
                            ></v-autocomplete>
                            <p class="issuing-bank-text">Выплаты на карты Тбанка не производятся</p>
                        </v-flex>
                    </v-layout>

                    <v-layout pt-2 row wrap v-if="type === 'physical'">
                        <v-flex xs12 md6 lg6 py-0 class="requisites-label">
                            <v-checkbox
                                v-model="requisitesApproved"
                                :rules="[rules.approve]"
                                validate-on-blur
                            >
                                <template v-slot:label>
                                    Я осознаю, что ошибка в реквизитах приведет к безвозвратной потере денежных
                                    средств, переведенных по неверным реквизитам
                                </template>
                            </v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-checkbox
                                v-model="profileApproved"
                                :rules="[rules.approve]"
                                validate-on-blur
                            >
                                <template v-slot:label>
                                    Подтверждаю достоверность указанных данных
                                </template>
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>

            <v-form ref="commissionForm" class="commission-form" v-model="commissionsValid"
                    v-show="tab === commissionsTab && isAdmin">
                <v-container style="max-width: 1200px">
                    <v-layout row wrap v-if="isAgent">
                        <v-flex xs12 md6 lg6 py-0>
                            <v-select
                                v-model="curatorId"
                                :items="curatorsList"
                                :rules="[rules.integer]"
                                label="Куратор"
                                :menu-props="{ bottom: true, offsetY: true }"
                                class="curator-select"
                            ></v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-text-field
                                v-model="commission"
                                :rules="[rules.commission]"
                                label="Процент вознаграждения по ОСАГО"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-select
                                v-model="commissionTemplateId"
                                :items="commissionTemplatesList"
                                :rules="[rules.integer]"
                                label="Шаблон вознаграждения ОСАГО"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true }"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-text-field
                                v-model="mortgageCommission"
                                :items="commissionTemplatesList"
                                :rules="[rules.commission]"
                                label="Процент вознаграждения по ипотечному страхованию"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-select
                                v-model="mortgageCommissionTemplateId"
                                :items="mortgageCommissionTemplatesList"
                                :rules="[rules.integer]"
                                label="Шаблон вознаграждения ипотечного страхования"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true }"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-text-field
                                v-model="transitCommission"
                                :rules="[rules.commission]"
                                label="Процент вознаграждения по полисам ОСАГО не РФ"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-select
                                v-model="transitCommissionTemplateId"
                                :items="transitCommissionTemplatesList"
                                :rules="[rules.integer]"
                                label="Шаблон вознаграждения ОСАГО не РФ"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true }"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-text-field
                                v-model="antimiteCommission"
                                :rules="[rules.commission]"
                                label="Процент вознаграждения по полисам Антиклещ"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg6 py-0>
                            <v-text-field
                                v-model="bankingProductsCommission"
                                :rules="[rules.commission]"
                                label="Процент вознаграждения по банковским продуктам"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1200px">
                    <v-layout pb-2 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="submitCommissionAndCurator"
                                   :disabled="false"
                                   class="submit-button block">Сохранить изменения
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>

            <widget-tab
                v-show="tab === widgetTab"
                :widgetId="widgetId"
                :widgetQrUrl="widgetQrUrl"
                :widgetCode="widgetCode"
                :widgetLink="widgetLink"
                :widgetReferralLink="widgetReferralLink"
                :useReferral="widgetUseReferral"
                :linksList="referralLinksList"
            />

            <v-container v-if="tab !== commissionsTab && tab !== widgetTab" style="max-width: 1200px">
                <v-layout pb-2 row wrap>
                    <v-flex xs12 sm6>
                        <v-btn @click="validate"
                               :disabled="false"
                               class="submit-button block">Сохранить изменения
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container style="max-width: 1200px">
                <h2 class="pb-3">Возникли вопросы?</h2>
                <v-layout row wrap pb-5>
                    <v-flex xs12 sm9 md8 lg7 py-0>
                        <h3><a href="tel:88002010643">8 800 201 06 43</a></h3>
                        <p style="font-size: 18px">Звоните, и наши менеджеры прояснят все моменты.</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import moment from "moment";
import WidgetTab from "./profile/WidgetTab";
import _ from "lodash";

export default {
    components: {WidgetTab},
    props: [
        'profile',
        'isProfile',
        'is-admin',
        'canEditType',
        'curators',
        'commission-templates',
        'mortgage-commission-templates',
        'transit-commission-templates',
        'widget',
        'salesTypes',
        'borderCrossings',
        'authUser',
    ],

    data: () => ({
        personalValid: true,
        requisitesValid: true,
        commissionsValid: true,
        curatorId: null,
        curatorsList: [],
        commissionTemplatesList: [],
        commissionTemplateId: 0,
        mortgageCommissionTemplatesList: [],
        mortgageCommissionTemplateId: 0,
        transitCommissionTemplatesList: [],
        transitCommissionTemplateId: 0,
        commission: '',
        mortgageCommission: '',
        antimiteCommission: '',
        bankingProductsCommission: '',
        transitCommission: '',
        startDate: '',
        status: 'approved',
        deleted: false,
        tab: 0,
        personalTab: 0,
        requisitesTab: null,
        commissionsTab: null,
        widgetTab: null,
        widgetQrUrl: 'https://getpolis.ru',
        widgetCode: null,
        widgetLink: null,
        widgetReferralLink: null,
        widgetUseReferral: false,
        widgetId: null,
        tabItems: ['Личные данные'],
        isAgent: false,
        passportMaxDate: null,
        type: '',
        userType: null,
        requisitesApproved: false,
        profileApproved: false,
        isJuridical: null,
        user: {
            id: null,
            phone: '+7',
            email: '',
            password: '',
            password_check: '',
            show_commission: false,
            show_commission_bp: false,
            is_egarant: false,
            egarant_company: null,
            egarant_company_name: null,
            border_crossing_id: null,
            sales_type: null,
        },
        snils: null,
        birthday: null,
        address: {
            search: '',
        },
        fio: {
            name: '',
            surname: '',
            patronymic: '',
        },
        passport: {
            series_number: '',
            date: '',
            issued_by: '',
            address: {
                search: '',
            },
        },
        city: {
            city: '',
            search: '',
            city_kladr: null,
            city_fias: null
        },
        bank: {
            inn: '',
            name: '',
            account_number: '',
            bik: '',
            kor_account: '',
            card_number: '',
            fio: '',
            issuing_bank: null,
        },
        jur: {
            simple_tax_system: false,
            fact_addr_eq_jur: false,
            name: '',
            kpp: '',
            ogrn: '',
            address: {
                search: '',
            },
            fact_address: {
                search: '',
            },
        },
        referralLinksList: [],
        productsPermissions: {
            isTransitOpen: false,
        },
        bankList: [],

        rules: {
            required: v => !!v || 'Обязательное поле',
            integer: v => Number.isInteger(v) || 'Обязательное поле',
            passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
            email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
            phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
            newPassword: v => v.length === 0 || v.length >= 7 || 'Пароль должен содержать не менее 7 символов',
            commission: v => (v >= 0 && v <= 100) || 'Введите число от 0 до 100',
            ogrn: v => /^(\d{13}|\d{15})$/.test(v) || 'Должен содержать 13 или 15 цифр',
            inn: v => /^\d{12}$/.test(v) || 'Должен содержать 12 цифр',
            innJuridical: v => /^\d{10}$/.test(v) || 'Должен содержать 10 цифр',
            kpp: v => v === null || v === '' || /^\d{9}$/.test(v) || 'Должен содержать 9 цифр',
            bik: v => /^\d{9}$/.test(v) || 'Должен содержать 9 цифр',
            accNumber: v => /^\d{20}$/.test(v) || 'Должен содержать 20 цифр',
            cardNumber: v => {
                const digits = (v || '').replace(/\s+/g, '')
                return (/^\d{16}$/.test(digits) || /^\d{18}$/.test(digits)) || 'Должно быть 16 или 18 цифр'
            },
            approve: v => v || 'Необходимо согласиться',
        },

        showPass: false,
    }),

    computed: {
        passwordCheckRule() {
            return () => this.user.password === this.user.password_check || 'Пароли не совпадают';
        },
        validateInn() {
            let result = false;
            let inn = this.bank.inn;

            if (!inn || !inn.length) {
                return true; // Конкретно в этом случае пропускаем валидацию
            } else if (/[^0-9]/.test(inn)) {
                return 'ИНН может состоять только из цифр';
            } else if ([10, 12].indexOf(inn.length) === -1) {
                return 'ИНН может состоять только из 10 или 12 цифр';
            } else {
                const checkDigit = function (inn, coefficients) {
                    let n = 0;
                    for (const i in coefficients) {
                        n += coefficients[i] * inn[i];
                    }
                    return parseInt(n % 11 % 10);
                };
                switch (inn.length) {
                    case 10:
                        const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
                        if (n10 === parseInt(inn[9])) {
                            result = true;
                        }
                        break;
                    case 12:
                        const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                        const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
                        if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                            result = true;
                        }
                        break;
                }
                if (!result) {
                    return 'Неправильный ИНН';
                }
            }
            return result;
        },
        salesTypesArray() {
            return Object.entries(this.salesTypesList).map(([value, text]) => ({
                value,
                text
            }));
        },
        borderCrossingsArray() {
            return Object.entries(this.borderCrossingsList).map(([value, text]) => ({
                value: Number(value),
                text
            }));
        },
        authUserIsAdmin() {
            return this.authUser.user_type === 'admin';
        },
        authUserIsCurator() {
            return this.authUser.user_type === 'curator';
        },
        authUserIsAgent() {
            return this.authUser.user_type === 'agent';
        },
        showSalesType() {
            return (this.authUserIsAdmin || this.authUserIsCurator) && this.curatorId !== 0 && this.user.id !== this.curatorId && this.userType == 'agent';
        },
        userProfileIsCurator() {
            return this.userType === 'curator';
        },
    },

    created: function () {
        this.getBankList();
        this.passportMaxDate = moment().format('YYYY-MM-DD');

        const profile = JSON.parse(window.atob(this.profile));
        this.userType = profile.userType;
        if (profile.type || profile.userType === 'agent') {
            this.isAgent = true;
        }

        this.status = profile.status;
        this.deleted = Boolean(profile.deleted_at);
        this.startDate = profile.created_at;

        this.user.id = profile.id;
        this.user.phone = profile.phone;
        this.user.email = profile.email;
        this.user.is_egarant = profile.is_egarant;
        this.user.egarant_company = profile.egarant_company;
        this.user.egarant_company_name = profile.egarant_company_name;
        this.city.search = this.city.city = profile.city;
        this.city.city_kladr = profile.city_kladr;
        this.city.city_fias = profile.city_fias;
        this.user.sales_type = profile.sales_type;
        this.user.border_crossing_id = profile.border_crossing_id;

        this.salesTypesList = JSON.parse(this.salesTypes)
        this.borderCrossingsList = JSON.parse(this.borderCrossings)

        this.fio = profile.fio;

        if (profile.isTransitOpen) {
            this.productsPermissions.isTransitOpen = profile.isTransitOpen;
        }

        if (profile.show_commission_bp) {
            this.user.show_commission_bp = profile.show_commission_bp;
        }

        if (this.isAgent) {
            this.tabItems.push('Реквизиты');
            this.requisitesTab = this.tabItems.length - 1;
            this.type = profile.type
            this.address.search = profile.address
            this.birthday = profile.birthday
            this.snils = profile.snils

            if (profile.passport) {
                this.passport.series_number = profile.passport.series_number;
                this.passport.date = profile.passport.date;
                this.passport.issued_by = profile.passport.issued_by;
                this.passport.address.search = profile.passport.address;
            }
            if (profile.bank) {
                this.bank = profile.bank;
            }

            if (profile.jur) {
                this.jur.simple_tax_system = profile.jur.simple_tax_system;
                this.jur.address.search = profile.jur.address;
                this.jur.fact_addr_eq_jur = profile.jur.address === profile.jur.fact_address;
                this.jur.fact_address.search = profile.jur.fact_address;
                this.jur.kpp = profile.jur.kpp;
                this.jur.name = profile.jur.name;
                this.jur.ogrn = profile.jur.ogrn;
            }

            if (this.isAdmin) {
                this.curatorsList = JSON.parse(window.atob(this.curators));
                this.curatorId = profile.curator_id;

                this.tabItems.push('Куратор и вознаграждение');
                this.commissionsTab = this.tabItems.length - 1;
            }

            if (!this.user.is_egarant && this.isProfile) {
                this.tabItems.push('Виджет и QR-код')
                this.widgetTab = this.tabItems.length - 1;
                if (this.widget) {
                    const widget = JSON.parse(window.atob(this.widget));
                    if (widget) {
                        this.widgetId = widget.id;
                        this.widgetCode = widget.code;
                        this.widgetQrUrl = widget.url;
                        this.widgetLink = this.widgetReferralLink = widget.referral;
                        this.widgetUseReferral = widget.useReferral;
                        this.referralLinksList = widget.referralLinks;
                    }
                }
            }
        } else {
            this.user.show_commission = profile.show_commission;

            if (this.isAdmin) {
                this.tabItems.push('Вознаграждение');
                this.commissionsTab = this.tabItems.length - 1;
            }
        }

        // комиссия
        if (this.isAdmin) {
            this.commission = profile.commission;
            console.log(this.commission);
            if (profile.mortgage_commission) {
                this.mortgageCommission = profile.mortgage_commission;
            } else if (profile.commission) {
                this.mortgageCommission = profile.commission;
            }

            if (profile.antimite_commission) {
                this.antimiteCommission = profile.antimite_commission;
            }
            if (profile.bp_commission) {
                this.bankingProductsCommission = profile.bp_commission;
            }

            if (profile.transit_commission) {
                this.transitCommission = profile.transit_commission;
            } else if (profile.commission) {
                this.transitCommission = profile.commission;
            }

            if (typeof this.commissionTemplates === 'string') {
                this.commissionTemplatesList = JSON.parse(this.commissionTemplates);
            } else {
                this.commissionTemplatesList = JSON.parse(JSON.stringify(this.commissionTemplates));
            }

            if (typeof this.mortgageCommissionTemplates === 'string') {
                this.mortgageCommissionTemplatesList = JSON.parse(this.mortgageCommissionTemplates);
            } else {
                this.mortgageCommissionTemplatesList = JSON.parse(JSON.stringify(this.mortgageCommissionTemplates));
            }

            if (typeof this.transitCommissionTemplatesList === 'string') {
                this.transitCommissionTemplatesList = JSON.parse(this.transitCommissionTemplates);
            } else {
                this.transitCommissionTemplatesList = JSON.parse(JSON.stringify(this.transitCommissionTemplates));
            }

            this.commissionTemplatesList.unshift({'id': 0, 'name': 'Шаблон не установлен'});
            this.mortgageCommissionTemplatesList.unshift({'id': 0, 'name': 'Шаблон не установлен'});
            this.transitCommissionTemplatesList.unshift({'id': 0, 'name': 'Шаблон не установлен'});

            this.commissionTemplateId = profile.commission_template_id || 0;
            this.mortgageCommissionTemplateId = profile.mortgage_commission_template_id || 0;
            this.transitCommissionTemplateId = profile.transit_commission_template_id || 0;
        }
    },

    methods: {
        changeType(value) {
            if (value === 'juridical' && this.bank.inn.length > 10) {
                this.bank.inn = this.bank.inn.slice(0, 10)
            }

            this.requisitesApproved = false;
        },

        validate() {
            const personalValid = this.$refs.personalForm.validate();
            const requisitesValid = this.requisitesTab === null || this.$refs.requisitesForm.validate();
            const valid = personalValid && requisitesValid;
            if (valid) {
                this.submit();
            } else {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    if (!personalValid) {
                        this.tab = this.personalTab;
                    } else if (!requisitesValid) {
                        this.tab = this.requisitesTab;
                    }
                    this.$nextTick(() => {
                        this.goToFirstError();
                    });
                });
            }
        },

        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },

        submit() {
            let body = {
                user: this.user,
                fio: this.fio,
                city: this.city,
                isTransitOpen: this.productsPermissions.isTransitOpen
            };

            if (this.isAgent) {
                let jur = (this.type === 'juridical' || this.type === 'sole-proprietor') ? _.cloneDeep(this.jur) : null;

                let passport = _.cloneDeep(this.passport);
                passport.address = passport.address.search;

                body = {
                    type: this.type,
                    user: this.user,
                    snils: this.snils,
                    birthday: this.birthday,
                    address: this.address.search,
                    fio: this.fio,
                    city: this.city,
                    passport: passport,
                    bank: this.bank,
                    jur: jur,
                    profileApproved: this.profileApproved,
                    isTransitOpen: this.productsPermissions.isTransitOpen,
                };
            } else {
                body.type = 'operator';
                body.profileApproved = this.profileApproved;
            }

            axios.post(window.location, body).then(() => {
                PNotify.success('Изменения успешно сохранены.');
            }).catch(error => {
                console.log(error);
                if (error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
            });
        },

        submitCommissionAndCurator() {
            const commissionValid = this.commissionsTab === null || this.$refs.commissionForm.validate();
            if (commissionValid) {
                let body = {};
                body.commission_template_id = this.commissionTemplateId;
                body.mortgage_commission_template_id = this.mortgageCommissionTemplateId;
                body.transit_commission_template_id = this.transitCommissionTemplateId;
                if (this.commission) {
                    body.commission = this.commission;
                }

                if (this.mortgageCommission) {
                    body.mortgage_commission = this.mortgageCommission;
                } else if (this.commission) {
                    body.mortgage_commission = body.commission;
                }

                if (this.antimiteCommission) {
                    body.antimite_commission = this.antimiteCommission;
                }
                if (this.bankingProductsCommission) {
                    body.bp_commission = this.bankingProductsCommission;
                }

                // Если выбран шаблон, обязательно передаем transit_commission
                // чтобы на бэкенде условие isset($data->transit_commission_template_id) && isset($data->transit_commission) выполнилось
                if (this.transitCommissionTemplateId && this.transitCommissionTemplateId > 0) {
                    body.transit_commission = this.transitCommission || this.commission || '';
                } else if (this.transitCommission) {
                    body.transit_commission = this.transitCommission;
                } else if (this.commission) {
                    body.transit_commission = this.commission;
                }

                if (this.isAgent) {
                    body.curator_id = this.curatorId;
                }
                axios.post(window.location + '/commissions', body).then(() => {
                    PNotify.success('Изменения успешно сохранены.');
                }).catch(error => {
                    console.log(error);
                    if (error.response.data.message) {
                        PNotify.alert(error.response.data.message);
                    }
                });
            } else {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.$nextTick(() => {
                        this.goToFirstError();
                    });
                });
            }
        },

        approve() {
            axios.get(window.location + '/approve')
                .then(response => {
                    this.status = response.data.status;
                }).catch(error => {
                console.log(error);
                if (error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
            });
        },

        ban() {
            axios.get(window.location + '/ban')
                .then(response => {
                    this.status = response.data.status;
                }).catch(error => {
                console.log(error);
                if (error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
            });
        },

        del() {
            PNotify.error({
                text: 'Удалить пользователя?',
                hide: false,
                stack: {
                    'dir1': 'down',
                    'modal': true,
                    'firstpos1': 25
                },
                modules: {
                    Confirm: {
                        confirm: true,
                        buttons: [
                            {
                                text: 'Удалить',
                                primary: false,
                                click: function () {
                                    axios.delete(window.location)
                                        .then(() => {
                                            this.deleted = true;
                                            window.location.href = '/agents';
                                        }).catch(error => {
                                        console.log(error);
                                        if (error.response.data.message) {
                                            PNotify.alert(error.response.data.message);
                                        }
                                    });
                                },
                            },
                            {
                                text: 'Отмена',
                                primary: false,
                                click: () => {
                                    PNotify.removeAll();
                                },
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    },
                    History: {
                        history: false
                    }
                }
            });
        },

        async getBankList() {
            try {
                const baseUrl = window.location.origin;

                if (this.user && this.user.id) {
                    const response = await axios.get(`${baseUrl}/get-bank-list`);
                    this.bankList = response.data;
                } else {
                    const response = await axios.get(`${baseUrl}/agent/${this.authUser.id}/get-bank-list`);
                    this.bankList = response.data;
                }
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data && error.response.data.message) {
                    PNotify.alert(error.response.data.message);
                }
            }
        },
    },

    watch: {
        'bank': {
            handler() {
                this.requisitesApproved = false;
            },
            deep: true,
        },
        'jur.name': {
            handler() {
                this.requisitesApproved = false;
            },
        },
        'passport.series_number': {
            handler() {
                this.requisitesApproved = false;
            },
        },
        'birthday': {
            handler() {
                this.requisitesApproved = false;
            },
        },
        'address': {
            handler() {
                this.requisitesApproved = false;
            },
        },
    },
}
</script>

<style scoped>
/deep/ .hidden {
    visibility: hidden;
    height: 1px;
}

.requisites-label {
    .v-label {
        font-family: 'SFProBold';
    }
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 20px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    background-color: #00ba57 !important;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: nowrap;
    padding: 0 50px;
    line-height: 1.1;
    @media(max-width: 600px) {
        padding: 0 30px;
    }
}

.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
    @media(max-width: 600px) {
        font-size: 45px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

.agent-actions a {
    color: black;
    margin-right: 40px;
}

.agent-actions a img {
    margin-right: 5px;
    width: 21px;
    height: 21px;
    vertical-align: -5px;
}

.agent-actions a.disabled {
    color: grey;
}

.agent-actions a.disabled img {
    color: grey;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

h3 a {
    color: #000;
    text-decoration: none;
}

h3 a:hover {
    color: #000;
    text-decoration: none;
}

.pointer {
    cursor: pointer;
}

.issuing-bank-text {
    padding: 0 10px;
}
</style>
<style>
.curator-select {
    input {
        display: none;
    }

    .v-select__selections {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/Profile.vue